"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaMaxWidth = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _matisseReact = require("@goodrx/matisse-react");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      @media (max-width: ", ") {\n        ", ";\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mediaMaxWidth = function mediaMaxWidth(styles) {
  return function (_ref) {
    var theme = _ref.theme;
    return Object.keys(styles).map(function (breakpoint) {
      return (0, _matisseReact.css)(_templateObject(), theme.breakpoints[breakpoint], styles[breakpoint]);
    });
  };
};

exports.mediaMaxWidth = mediaMaxWidth;